import React, { Component } from 'react';
import FormattedInput from './FormattedInput';
import { joinClasses, emptyString } from '../../../utils/helpers';

import './textInput.scss';

/** @import {CurrencyInputProps, CurrencyInputState} from './CurrencyInputTypes' */

/** @extends {Component<CurrencyInputProps, CurrencyInputState>} */
class CurrencyInput extends Component {
  state = {
    value: '',
    rawValue: ''
  };

  static getDerivedStateFromProps(/** @type {CurrencyInputProps} */ props) {
    if (!props.hasOwnProperty('value')) return null;
    return {
      value: props.value || ''
    };
  }

  handleChangeRawValue = (/** @type {string} */ value) => {
    this.setState({ rawValue: value });
    this.props.onChange && this.props.onChange(value);
  }

  handleChange = (/** @type {string} */ value) => {
    this.setState({ value: value });
    this.props.onChange && this.props.onChange(value);
  }

  handleOnBlur = (/** @type {React.FocusEvent<HTMLInputElement, Element>} */ e) => {
    //@ts-expect-error I think this code is incorrect - it expects a rawValue property on the event target which doesn't exist see https://stackoverflow.com/a/62083623/761388
    let val = e.target.rawValue;

    if (val) {
      val = (Math.round(val * 100) / 100).toFixed(2)
    }

    this.setState({ value: val });
    this.props.onChange && this.props.onChange(val);
  }

  hasFailedRule() {
    if (emptyString(this.state.rawValue) || !this.props.rule) return;
    return !this.props.rule.test(this.state.rawValue);
  }

  getErrorClassNames() {
    return joinClasses(
        'currency__error',
        this.hasFailedRule() ? 'currency__error--fail' : ''
    );
  }

  renderErrors() {
    if (!this.props.rule) return;

    return (
        <ul className='currency__errors'>
          <li className={this.getErrorClassNames()}>{this.props.rule.label}</li>
        </ul>
    );
  }

  render() {
    const { name, placeholder, className, hasError, rule } = this.props;

    return (
        <div className='currency__wrapper'>
          <div className='currency__container'>
            <FormattedInput
                name={name}
                value={this.state.value}
                className={className || 'currency__input'}
                placeholder={`${placeholder}${rule ? ' *' : ''}`}
                onChange={this.handleChange}
                onChangeRawValue={this.handleChangeRawValue}
                onBlur={this.handleOnBlur}
                options={{ numeral: true, numeralThousandsGroupStyle: 'thousand', numeralPositiveOnly: true }}
                type="text"
                hasError={hasError || false}
            />
            <div className="currency__prefix">£</div>
          </div>
          {this.renderErrors()}
        </div>
    );
  }
}


export default CurrencyInput;
